module.exports = __webpack_public_path__ + "media/images/icons/filled/edit-fddbd4a0a36f8ed6c225d20a60c29ad7.svg";